import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  paper: {
    maxWidth: "825px",
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
    },
  },
  titleContainer: {
    backgroundColor: "#E2E7EF",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
  },
  subtitle: {
    fontSize: "1.4rem",
  },
  contentTitles: {
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(2),
  },
  textfield: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
    },
  },
  button: {
    marginLeft: theme.spacing(2),
    borderRadius: "50%",
  },
  disabledText: {
    color: "#898989",
    fontSize: "1.3rem",
    marginBottom: theme.spacing(2),
  },
}))

export default styles
